import { render, staticRenderFns } from "./DAvatar.vue?vue&type=template&id=9c7d2bce&scoped=true"
import script from "./DAvatar.vue?vue&type=script&lang=js"
export * from "./DAvatar.vue?vue&type=script&lang=js"
import style0 from "./DAvatar.vue?vue&type=style&index=0&id=9c7d2bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7d2bce",
  null
  
)

export default component.exports